import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, WhatsappAccountAlertsResponseDataSchema } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof WhatsappAccountAlertsResponseDataSchema>>

const queryKey = ["whatsappAccountAlerts"]

export const whatsappAccountAlertsQuery = () => {
  return queryOptions({
    queryKey,
    queryFn: async () => {
      const response = await axios.get<Response>("/integrations/whatsapp/account-alerts")

      return response.data.data
    },
  })
}
